const basicLeadsPath = (routePath = '') =>
  `listings${routePath && '/'}${routePath}`;

export const getLeads = () => basicLeadsPath();

export const getLead = (id: string) => basicLeadsPath(id);

export const confirmLead = (id: string) => basicLeadsPath(`${id}/confirm-lead`);

export const declineLead = (id: string) => basicLeadsPath(`${id}/decline-lead`);

export const updateLead = (id: string) => basicLeadsPath(`${id}/update-lead`);

export const getLeadStatusCounts = () => basicLeadsPath(`counts`);

export const findLeads = (id: string) => basicLeadsPath(`${id}/find-leads`);

export const selectLead = (listingId: string, apolloLeadId: string) =>
  basicLeadsPath(`${listingId}/select-lead/${apolloLeadId}`);

export const generateEmail = (id: string) =>
  basicLeadsPath(`${id}/generate-outreach-email`);

export const createLead = () => basicLeadsPath();

export const updateListing = (id: string) => basicLeadsPath(`${id}`);
